import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import TermsAndConditions from "./TermsAndConditions";

import { GET_Quotation,POST_Quotation,PATCH_Quotation } from "../../slices/thunks";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Label,
  Input,
  Alert
} from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import CPBreadCrumbMasters from "../../Components/CPComponents/CPLayouts/CPBreadCrumbMasters";
import InfoButtonWithTooltip from "../../Components/CPComponents/CPIcons/InfoToolTip";
const OrderDetails = () => {
  const { state } = useLocation();
  const { order: initialOrder } = state || {};
  console.log(state);
  const dispatch=useDispatch();
  /*
  line number 24,25,26 ko remove karna h and uske baad all we would need to do is
  const url = window.location.href;
  const queryParams = new URL(url).searchParams;
  const quotationID = queryParams.get("QuotationID");
  const data = useSelector((state) => state.VendorDashboard.data);
  const loading = useSelector((state) => state.VendorDashboard.loading);
  const error = useSelector((state) => state.VendorDashboard.error);
  const success = useSelector((state) => state.VendorDashboard.success)
  useEffect(()=>{
    dispatch(GET_Quotation(quotationID));
    },[quotationID])
  const initialOrder = data || {};
  */
  const [order, setOrder] = useState(initialOrder);
  const [modal, setModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [availability, setAvailability] = useState("available");
  const [freight, setFreight] = useState("");
  const [gst, setGst] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [vendorDiscount,setVendorDiscount] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const [vendorNo, setVendorNo] = useState("");
  const [vendorDate, setVendorDate] = useState(today);
  const [errorMessage,setErrorMessage]=useState("");
  useEffect(()=>{
    setVendorNo(order.vendor.documentNumber);
    setVendorDate(order.vendor.date);
  },[order])
  const validationSchemaIfPending = (availability==="available")?(Yup.object({
    quantity: Yup.number()
      .min(0, "Quantity must be 0 or greater")
      .required("Quantity is required")
      .max(((selectedItem)?(selectedItem.RequiredQuantity):(0)),"Quantity must be less than or equal to required quantity"),
    rate: Yup.number()
      .min(0, "Rate must be 0 or greater")
      .required("Rate is required"),
    discount: Yup.number().min(0, "Discount cannot be negative"),
    hsn: Yup.number()
      .integer("HSN must be a whole number")
      .required("HSN is required"),
    unit: Yup.string()
      .oneOf(["MTS", "KG"], "Unit is required") // Validate that the unit is either MTS or KG
      .required("Unit is required"), // Ensure unit is selected
  })) : (Yup.object({
    quantity: 0,
    rate: 0,
    discount: 0,
    hsn: 0,
    unit: 0
  }));
  const validationSchemaIfNotPending = (availability === "available") ? (Yup.object({
    quantity: Yup.number()
      .min(0, "Quantity must be 0 or greater"),
      
    rate: Yup.number()
      .min(0, "Rate must be 0 or greater"),
      
    discount: Yup.number().min(0, "Discount cannot be negative"),
    hsn: Yup.number()
      .integer("HSN must be a whole number"),
      
    unit: Yup.string()
      .oneOf(["MTS", "KG"], "Unit is required"), // Validate that the unit is either MTS or KG
       // Ensure unit is selected
  })) : (Yup.object({
    quantity: 0,
    rate: 0,
    discount: 0,
    hsn: 0,
    unit: 0
  }));
  
  const calculateAmount = (quantity, rate, discount, tax) => {
    const totalAmount = quantity * rate;
    const discountAmount = (totalAmount * discount) / 100;
    const discountedAmount = totalAmount - discountAmount;
    const taxAmount = (discountedAmount * tax) / 100;

    const finalAmount = Math.max(discountedAmount , 0);

    return {
      finalAmount: parseFloat(finalAmount.toFixed(2)),
      taxAmount: parseFloat(taxAmount.toFixed(2)),
    };
  };


  const calculateGSTTotal = () => {
    let subtotal = parseFloat(order.items.reduce((total, item) => total + (item.amount || 0), 0)).toFixed(2);
    const freightValue = parseFloat(freight) || 0;
    const discountValue = parseFloat(discount) || 0;
    const gstValue = parseFloat(gst) || 0;

    const discountAmount = (subtotal * discountValue) / 100;
    subtotal -= discountAmount;
    const gstAmount = (subtotal * gstValue) / 100;
    subtotal += gstAmount;
    subtotal += freightValue;

    return parseFloat(subtotal.toFixed(2));
  };

  const calculateSubTotal = () => {
    return parseFloat((order.items.reduce((total, item) => total + (item.amount || 0), 0) ).toFixed(2));

  };

  const calculateTotal = () => {
    let subtotal = parseFloat(order.items.reduce((total, item) => total + (item.amount || 0), 0)).toFixed(2);
    const freightValue = parseFloat(freight) || 0;
    const discountValue = parseFloat(discount) || 0;
    const gstValue = parseFloat(gst) || 0;

    const discountAmount = (subtotal * discountValue) / 100;
    subtotal -= discountAmount;
    
    subtotal += gstValue;
    subtotal += freightValue;
    subtotal-=vendorDiscount;

    return parseFloat(subtotal.toFixed(2));
  };

  const handleSave = (values) => {
    const updatedItems = [...order.items];
    const newAmount =
      availability === "regret"
        ? 0
        : calculateAmount(
            values.quantity,
            values.rate,
            values.discount,
            values.tax
          ).finalAmount;

    updatedItems[selectedIndex] = {
      ...selectedItem,
      VendorStatus:availability,
      VendorQuantity: availability === "regret" ? 0 : values.quantity,
      VendorRate: availability === "regret" ? 0 : values.rate,
      amount: newAmount,
      description: values.description,
      tax: values.tax,
      hsn: availability === "regret" ? 0 : values.hsn, // Setting HSN to 0 on regret
      discount: availability === "regret" ? 0 : values.discount,
      unit: availability === "regret" ? "" : values.unit,
      
    };
    setOrder({ ...order, items: updatedItems });
    toggleModal();
   
  };
 

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "won":
        return "badge bg-success-subtle text-success";
      case "expired":
        return "badge bg-danger-subtle text-danger";
      case "lost":
        return "badge bg-light-subtle text-muted";
      default:
        return "badge bg-warning-subtle text-warning";
    }
  };
  const toggleModal = () => setModal(!modal);
  //data for terms and conditions
  const [termsData, setTermsData] = useState({ vendorInputs: {}, checkboxes: {} });

  const handleDataChange = (data) => {
    setTermsData(data);
  };
  const handleSaveButton = () => {
    // Check if any item in the order has amount 0 and VendorStatus is "available"
    const invalidItems = order.items.filter(
      (item) => (item.amount === 0||item.amount==="") && (item.VendorStatus.toLowerCase() === "available"||item.VendorStatus.toLowerCase()==="")
    );

    if (invalidItems.length > 0) {
      setErrorMessage("Please mark as regret or fill the details for all items.");
      return;
    }

    // Check if there are any items with VendorStatus as "available"
    const hasAvailableItems = order.items.some(
      (item) => item.VendorStatus.toLowerCase() === "available"
    );

    // Validate terms only if any item is marked "available"
    if (hasAvailableItems) {
      const invalidTerms = termsData.some(
        (term) => term.checkbox === undefined || term.vendorResponse === undefined
      );

      if (invalidTerms) {
        setErrorMessage("Please go through all the terms and conditions.");
        return;
      }
    }

    setErrorMessage(""); // Clear the error message if validation passes

    // Proceed with the rest of the logic if no errors
    if (order.plant.status.toLowerCase() === "pending") {
      const summary = {
        TotalAmount: calculateTotal(),
        Gst: gst,
        Freight: freight,
        VendorDiscount: vendorDiscount,
        SubTotal: calculateSubTotal(),
      };

      const OrderAndTerms = {
        plant: order.plant,
        vendor: order.vendor,
        items: order.items,
        terms: termsData,
        summary: summary,
      };

      console.log(OrderAndTerms);
    }
  };



  const formatIndianAmount = (amount) => {
    const num = parseFloat(amount || 0).toFixed(2);
    const [whole, decimal] = num.split('.');
    const lastThree = whole.substring(whole.length - 3);
    const otherNumbers = whole.substring(0, whole.length - 3);
    const withCommas = otherNumbers ? otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree : lastThree;
    return `₹${withCommas}.${decimal}`;
  };
  return (
    <div className="page-content">
      <Container fluid>
        <CPBreadCrumbMasters title={order.plant.name} pageTitle={order.plant.documentNumber} data={order?.plant}/>
        <Col>
          <Card>
            <CardHeader className="p-4">
              {errorMessage && <Alert color="danger">{errorMessage}</Alert>}

              <Row className="align-items-center mb-3">
                <Col className="d-flex align-items-center">
                  <h5 className="mb-0 cursor-pointer">
                    <InfoButtonWithTooltip data={order.vendor} id="toolTipOrderDetails" />
                    {order.vendor.name}
                    
                  </h5>
                </Col>
                <Col className="text-end">
                  <div className="text-muted mb-0">
                    <strong>Order Status:</strong>{" "}
                    <span className={getStatusClass(order.plant.status)}>
                      {order.plant.status}
                    </span>
                  </div>
                </Col>
              </Row>
              

              <Row className="mt-0">
                {/* Vendor Information */}
                <div className="d-flex flex-wrap align-items-center gap-2">
                  
                  
                  <div className="d-flex align-items-center">
                    <i className="ri-hashtag text-primary me-2"></i>
                    
                    <input
                      type="text"
                      value={vendorNo}
                      onChange={(e) => setVendorNo(e.target.value)}
                      className="form-control ms-2 w-auto"
                      style={{ maxWidth: "180px" }}
                    />
                  </div>
                  <div className="d-flex align-items-center">
                    <i className="ri-calendar-check-line text-primary me-2"></i>
                    
                    <input
                      type="date"
                      value={vendorDate}
                      onChange={(e) => setVendorDate(e.target.value)}
                      className="form-control ms-2 w-auto"
                      style={{ maxWidth: "180px" }}
                    />
                  </div>
                </div>
              </Row>

            </CardHeader>

            <CardBody>
              <div className="table-responsive table-card">
                <table className="table table-borderless align-middle mb-0 table-sm">
                  <thead className="table-light text-muted">
                    <tr>
                      <th colSpan="2" scope="col">
                        Particulars
                      </th>
                      <th scope="col" className="text-end">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {order.items.map((item, index) => (
                      <tr key={index}>
                        <td
                          colSpan="2"
                          onClick={() => {
                            setSelectedItem(item);
                            setSelectedIndex(index);
                            toggleModal();
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <h5 className="fs-14">
                            {` ${item.name} - ${item.VendorQuantity} pcs`}{" "}
                          </h5>

                          {item.amount ? (
                            <p className="text-muted mb-0">
                              &#8377; {item.VendorRate} x {item.VendorQuantity} {item.unit}{" "}
                              | Discount: {item.discount}%
                            </p>
                          ) : item.VendorStatus === "regret" ? (
                            <p className="text-danger mb-0">Regret</p>
                          ) : (
                            <p className="text-warning mb-0">Not filled yet</p>
                          )}
                        </td>
                        <td className="text-end">
                          {formatIndianAmount(parseFloat((item.amount || 0).toFixed(2)))}
                        </td>

                      </tr>
                    ))}
                    <tr className="table-active">
                      <th colSpan="2">Sub Total:</th>
                      <td className="text-end">
                        <span className="fw-semibold">
                          {formatIndianAmount(calculateSubTotal())}
                        </span>
                      </td>
                    </tr>
                    <tr className="table-active">
                      <th colSpan="2">
                        Discount <span style={{ fontSize: '0.8em', color: '#6c757d' }}>(with GST)</span>
                      </th>

                      <td className="text-end">
                        ₹ <Input
                          type="number"
                          min="0"
                          value={vendorDiscount}
                          onChange={(e) =>
                            setVendorDiscount(parseFloat(e.target.value) || 0)
                          }
                          className="form-control-sm text-end"
                          style={{ width: "80px", display: "inline-block" }}
                        />
                      </td>
                    </tr>
                    <tr className="table-active">
                      <th colSpan="2">Freight <span style={{ fontSize: '0.8em', color: '#6c757d' }}>(with GST)</span></th>
                      <td className="text-end">
                        ₹ <Input
                          type="number"
                          min="0"
                          value={freight}
                          onChange={(e) =>
                            setFreight(parseFloat(e.target.value) || 0)
                          }
                          className="form-control-sm text-end"
                          style={{ width: "80px", display: "inline-block" }}
                        />
                      </td>
                    </tr>
                    <tr className="table-active">
                      <th colSpan="2">GST</th>
                      <td className="text-end">
                        <span className="fw-semibold">{formatIndianAmount(gst)}</span>
                      </td>
                    </tr>
                    <tr className="table-active">
                      <th colSpan="2">Total</th>
                      <td className="text-end">
                        <span className="fw-semibold">{formatIndianAmount(calculateTotal())}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col>
          <TermsAndConditions onDataChange={handleDataChange} currentTerms={order.terms}/>
        </Col>
        <Col>
          <div style={{ display: 'flex', justifyContent: 'center' ,paddingTop:'10px'}}>
            <Button color="primary" onClick={handleSaveButton} className="mt-6">
              Save
            </Button>
          </div>
        </Col>
        

      </Container>

      {selectedItem && (
        <Modal isOpen={modal} toggle={toggleModal}>
          <ModalHeader toggle={null} className="p-0 d-block " style={{ width: '100%' }}>
            <div className="bg-light p-4 rounded" style={{ width: '100%' }}>
              {/* Item Details */}
              <div
                style={{
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  padding: "10px",
                  backgroundColor: "#f8f9fa",
                  marginBottom: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <h5 style={{ margin: 0 }}>{selectedItem.name}</h5>
                  <button
                    className="btn-link p-0 border-0 bg-transparent"
                    onClick={toggleModal}
                    style={{ fontSize: "20px", color: "#6c757d", cursor: "pointer" }}
                  >
                    <i className="ri-close-line"></i>
                  </button>
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#6c757d",
                    marginBottom: "10px",
                  }}
                >
                  Make: {selectedItem.RequiredMake} | Quantity: {selectedItem.RequiredQuantity} Pcs
                </div>
                <div style={{ fontSize: "12px", color: "#6c757d" }}>
                  {selectedItem.RequiredDescription}
                </div>
              </div>

              {/* Status Section */}
              
            </div>
          </ModalHeader>


          <ModalBody>
            <div
              style={{
                border: "1px solid #dee2e6",
                borderRadius: "5px",
                padding: "10px",
                backgroundColor: "#f8f9fa",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#198754",
                    marginRight: "10px",
                  }}
                >
                  Status:
                </span>
                <div className="d-flex">
                  <div className="form-check me-3">
                    <Input
                      type="radio"
                      name="availability"
                      value="available"
                      id="available"
                      checked={availability === "available"}
                      onChange={(e) => setAvailability(e.target.value)}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="available">
                      Available
                    </label>
                  </div>
                  <div className="form-check">
                    <Input
                      type="radio"
                      name="availability"
                      value="regret"
                      id="regret"
                      checked={availability === "regret"}
                      onChange={(e) => setAvailability(e.target.value)}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="regret">
                      Regret
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br/>
            <Formik
              initialValues={{
                quantity: selectedItem.VendorQuantity||"",
                rate: selectedItem.VendorRate || "",
                discount: selectedItem.discount || "",
                description: selectedItem.description || "",
                tax: selectedItem.tax || "0",
                hsn: selectedItem.hsn || "",
                unit: selectedItem.unit || "MTS", // Initialize unit with default value
                amount: calculateAmount(
                  selectedItem.quantity || 0,
                  selectedItem.rate || 0,
                  selectedItem.discount || 0
                ).finalAmount,
              }}
              validationSchema={(order.plant.status!="Pending")?(validationSchemaIfNotPending):(validationSchemaIfPending)}
              onSubmit={handleSave}
            >
              {({ values, errors, touched, handleChange, setFieldValue }) => (
                <Form>
                  
                  <Row>
                    <Col>
                      <Label for="quantity">Quantity</Label>
                      <Input
                        type="number"
                        name="quantity"
                        id="quantity"
                        value={values.quantity}
                        min="0"
                        onChange={(e) => {
                          handleChange(e);
                          const { taxAmount: taxAmount1 } = calculateAmount(
                            values.quantity,
                            values.rate,
                            values.discount,
                            values.tax
                          );
                          setGst((prevGst) => parseFloat(prevGst) - taxAmount1);
                          const { finalAmount, taxAmount: taxAmount2 } = calculateAmount(
                            e.target.value,
                            values.rate,
                            values.discount,
                            values.tax,
                          );
                          setGst((prevGst) => parseFloat(prevGst) + taxAmount2);
                          // Update GST
                          setFieldValue("amount", finalAmount);
                        }}
                        disabled={availability==="regret"||order.plant.status!="Pending"}
                      />
                      <div className="text-danger">
                        {touched.quantity && errors.quantity}
                      </div>
                    </Col>
                    <Col>
                      <Label for="rate">Rate</Label>
                      <Input
                        type="number"
                        name="rate"
                        id="rate"
                        value={values.rate}
                        min="0"
                        onChange={(e) => {
                          handleChange(e);
                          const { taxAmount: taxAmount1 } = calculateAmount(
                            values.quantity,
                            values.rate,
                            values.discount,
                            values.tax
                          );
                          setGst((prevGst) => parseFloat(prevGst) - taxAmount1);
                          const { finalAmount, taxAmount: taxAmount2 } = calculateAmount(
                            values.quantity,
                            e.target.value,
                            values.discount,
                            values.tax,
                          );
                          setGst((prevGst) => parseFloat(prevGst) + taxAmount2);
                          // Update GST
                          setFieldValue("amount", finalAmount);
                        }}
                        disabled={availability === "regret" || order.plant.status != "Pending"}
                      />
                      <div className="text-danger">
                        {touched.rate && errors.rate}
                      </div>
                    </Col>

                    <Col>
                      <Label for="unit">Unit</Label>
                      <Input
                        type="select"
                        name="unit"
                        id="unit"
                        value={values.unit}
                        onChange={(e) => handleChange(e)}
                        disabled={availability === "regret" || order.plant.status != "Pending"}
                      >
                        <option value="MTS">MTS</option>
                        <option value="KG">KG</option>
                      </Input>
                    </Col>

                    <Col>
                      <Label for="discount">Discount (%)</Label>
                      <Input
                        type="number"
                        name="discount"
                        id="discount"
                        value={values.discount}
                        min="0"
                        onChange={(e) => {
                          handleChange(e);
                          const { taxAmount: taxAmount1 } = calculateAmount(
                            values.quantity,
                            values.rate,
                            values.discount,
                            values.tax
                          );
                          setGst((prevGst) => parseFloat(prevGst) - taxAmount1);
                          const { finalAmount, taxAmount: taxAmount2 } = calculateAmount(
                            values.quantity,
                            values.rate,
                            e.target.value,
                            values.tax,
                          );
                          setGst((prevGst) => parseFloat(prevGst) + taxAmount2);
                          // Update GST
                          setFieldValue("amount", finalAmount);
                        }}
                        disabled={availability === "regret" || order.plant.status != "Pending"}
                      />
                      <div className="text-danger">
                        {touched.discount && errors.discount}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Label for="description">Description</Label>
                      <Input
                        type="text"
                        name="description"
                        id="description"
                        value={values.description}
                        onChange={handleChange}
                        disabled={availability === "regret" || order.plant.status != "Pending"}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Label for="hsn">HSN Code</Label>
                      <Input
                        type="number"
                        name="hsn"
                        id="hsn"
                        value={values.hsn}
                        min="0"
                        onChange={handleChange}
                        disabled={availability === "regret" || order.plant.status != "Pending"}
                      />
                      <div className="text-danger">
                        {touched.hsn && errors.hsn}
                      </div>
                    </Col>
                    <Col>
                      <Label for="tax">Tax (%)</Label>
                      <Input
                        type="select"
                        name="tax"
                        id="tax"
                        value={values.tax}
                        min="0"
                        onChange={(e) => {
                          handleChange(e);
                          
                          const {  taxAmount:taxAmount1 } = calculateAmount(
                            values.quantity,
                            values.rate,
                            values.discount,
                            values.tax
                          );
                          setGst((prevGst) => parseFloat(prevGst) - taxAmount1);
                          const { finalAmount, taxAmount: taxAmount2 } = calculateAmount(
                            values.quantity,
                            values.rate,
                            values.discount,
                            e.target.value,
                          );
                          setGst((prevGst) => parseFloat(prevGst) + taxAmount2);
                          // Update GST
                          setFieldValue("amount", finalAmount);
                          
                          setFieldValue("tax",e.target.value);
                        }}
                        disabled={availability === "regret" || order.plant.status != "Pending"}
                      >
                        <option value="0">0%</option>
                        <option value="5">5%</option>
                        <option value="12">12%</option>
                        <option value="18">18%</option>
                        <option value="28">28%</option>
                      </Input>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Label for="amount">Amount</Label>
                      <Input
                        type="number"
                        name="amount"
                        id="amount"
                        value={values.amount}
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-end">
                      <Button type="submit" color="primary" disabled={ order.plant.status != "Pending"}>
                        Save
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </Modal>
      )}
    </div>
  );
};

export default OrderDetails;
